var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRunner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16.002",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 55911"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M10.622 3.542a1.76 1.76 0 1 0-1.255-.516 1.761 1.761 0 0 0 1.255.516Zm3.207.268a2.652 2.652 0 0 1-3.877.735 6.172 6.172 0 0 0-.635-.367 4.432 4.432 0 0 0-6.311 1.368c-.668.936.9 1.837 1.538.9a2.512 2.512 0 0 1 3.003-1.133 92.45 92.45 0 0 0-1.8 3.441c-.736 1.437-2.305 2.573-3.843 1.7a.931.931 0 1 0-1 1.57 4.534 4.534 0 0 0 5.783-1.1c.034 0 .1.033.133.033a11.6 11.6 0 0 1 2.768 1.644 14.367 14.367 0 0 1 1.5 2.906.904.904 0 0 0 1.637-.769 14.779 14.779 0 0 0-1.871-3.408 21.951 21.951 0 0 0-2.269-1.54c.569-1.069 1.137-2.1 1.738-3.14a4.415 4.415 0 0 0 5.046-1.939c.668-.935-.868-1.837-1.537-.9Z",
    "data-name": "Component 650 \\u2013 26"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h16v16H0z",
    "data-name": "Rectangle 17164"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRunner);
export default __webpack_public_path__ + "static/media/runner.e52434d4c5abdfa550310ef08872bff3.svg";
export { ForwardRef as ReactComponent };